import React, { useEffect, useState, useCallback } from "react";
import api from "@/lib/api";
import Navbar from "@/components/site/Navbar";
import Hero from "@/components/site/Hero";
import About from "@/components/site/About";
import Simulators from "@/components/site/Simulators";
import Stats from "@/components/site/Stats";
import Gallery from "@/components/site/Gallery";
import Differentials from "@/components/site/Differentials";
import Events from "@/components/site/Events";
import Testimonials from "@/components/site/Testimonials";
import Clients from "@/components/site/Clients";
import CTASection from "@/components/site/CTASection";
import Footer from "@/components/site/Footer";
import QuoteDialog from "@/components/site/QuoteDialog";
import Loader from "@/components/site/Loader";

export default function HomePage() {
  const [settings, setSettings] = useState(null);
  const [simulators, setSimulators] = useState([]);
  const [testimonials, setTestimonials] = useState([]);
  const [gallery, setGallery] = useState([]);
  const [clients, setClients] = useState([]);
  const [quoteOpen, setQuoteOpen] = useState(false);
  const [preselect, setPreselect] = useState(null);

  useEffect(() => {
    (async () => {
      try {
        const [s, sim, t, g, c] = await Promise.all([
          api.get("/settings"),
          api.get("/simulators"),
          api.get("/testimonials"),
          api.get("/gallery"),
          api.get("/clients"),
        ]);
        setSettings(s.data);
        setSimulators(sim.data);
        setTestimonials(t.data);
        setGallery(g.data);
        setClients(c.data);
        window.__SIMEXP_WHATS__ = s.data?.whatsapp || "";
        document.title = "SIM EXPERIENCE · Simuladores profissionais para eventos";
      } catch (e) {
        console.error(e);
      }
    })();
  }, []);

  const openQuote = useCallback((slug) => {
    setPreselect(typeof slug === "string" ? slug : null);
    setQuoteOpen(true);
  }, []);

  return (
    <div className="relative bg-black text-white overflow-hidden">
      <Loader />
      <Navbar onOpenQuote={openQuote} />
      <main>
        <Hero settings={settings} onOpenQuote={openQuote} />
        <About settings={settings} />
        <Simulators items={simulators} onOpenQuote={openQuote} />
        <Stats settings={settings} />
        <Gallery items={gallery} />
        <Differentials />
        <Events onOpenQuote={openQuote} />
        <Testimonials items={testimonials} />
        <Clients items={clients} />
        <CTASection onOpenQuote={openQuote} />
      </main>
      <Footer settings={settings} />
      <QuoteDialog
        open={quoteOpen}
        onClose={() => setQuoteOpen(false)}
        simulators={simulators}
        preselectSlug={preselect}
      />
    </div>
  );
}
